import { isEmptyInput, REQUIRED_ERROR_MESSAGE } from "@inrev/common";
import { z } from "zod";

z.config({
	customError: (iss) => {
		// Every field is rendered with a label, so an unfilled one only needs to say
		// that it's required — not that its empty value failed a type, enum, or
		// format check.
		if (isEmptyInput(iss.input)) return { message: REQUIRED_ERROR_MESSAGE };

		if (iss.code === "invalid_union") {
			// react-hook-form's zodResolver drops the underlying union member issues, so
			// this top-level message is all the user would ever see.
			// https://github.com/react-hook-form/resolvers/issues/788
			return { message: REQUIRED_ERROR_MESSAGE };
		}
	},
});
